<template>
  <footer class="footer">
    <p>&copy; koppla GmbH {{ new Date().getFullYear() }}</p>

    <div class="footer-links-container">
      <a :href="website.PRIVACY" target="_blank" rel="noopener noreferrer" class="footer-link">
        {{ $t('footer.privacy') }}
        <DsSvgIcon icon="link-external-01" size="xs" />
      </a>
      <a :href="website.IMPRINT" target="_blank" rel="noopener noreferrer" class="footer-link">
        {{ $t('footer.imprint') }}
        <DsSvgIcon icon="link-external-01" size="xs" />
      </a>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { website } from '@/utils/pages';
</script>

<style scoped>
.footer {
  @apply tw-w-full tw-flex tw-justify-between tw-fixed tw-bottom-2 tw-px-4;
  @apply tw-ds-text-sm--semibold tw-text-white tw-text-sm;
}

.footer-links-container {
  @apply tw-flex tw-gap-2;
}

.footer-link {
  @apply tw-flex tw-items-center tw-gap-1;
}
</style>
